import {MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Spinner, SpinnerSize, SpinnerStyle} from '@mintdata-wsp/common/components/spinner/Spinner';
import {SampleDesignResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/SampleDesignResponse';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {ButtonSize, ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import React from 'react';

const styles = require('./GrabDesignButton.module.less');
const cx = classnames.bind(styles) as any;

export enum ButtonState
{
    CopyToMyOrganization = 'Copy to My Organization',
    Copying = 'Copying Design...',
    GoToDesign = 'Go To Design',
    Error = 'Error',
}

interface IGrabDesignButtonProps
{
    designId:number;
}

interface IGrabDesignButtonState
{
    buttonState:ButtonState;
    spaceId:number;
    designId:number;
}

@observer
export class GrabDesignButton extends React.Component<IGrabDesignButtonProps, IGrabDesignButtonState>
{
    public constructor(props:IGrabDesignButtonProps)
    {
        super(props);

        let buttonState:ButtonState = ButtonState.CopyToMyOrganization;
        let spaceId:number;
        let designId:number;

        this.state = {
            buttonState,
            spaceId,
            designId,
        };
    }

    private _onClick = (event:React.MouseEvent<HTMLElement>):void =>
    {
        const {buttonState} = this.state;

        if( buttonState === ButtonState.CopyToMyOrganization )
        {
            this._copyDesign();
        }
        else if( buttonState === ButtonState.GoToDesign )
        {
            const {designId, spaceId} = this.state;

            if( !designId || !spaceId ) return;

            controllers.navigation.navigateTo(paths.design(spaceId, designId));
        }
        else if( buttonState === ButtonState.Error )
        {
            this.setState({buttonState: ButtonState.CopyToMyOrganization});
        }
    };

    private async _copyDesign()
    {
        const {designId} = this.props;
        const {siteId} = rootState.userSession.currentOrganization;

        this.setState({buttonState: ButtonState.Copying});

        const response:SampleDesignResponse | null = await controllers.ui.sampleDesign.grabSampleDesign(designId, siteId);

        if( response )
        {
            controllers.data.projects.syncAllProjects();
            // timeout is needed only for nice visual appearance of "Copying Design..." step
            setTimeout(() =>
            {
                this.setState({
                    spaceId: response.projectId,
                    designId: response.designId,
                    buttonState: ButtonState.GoToDesign
                });
            }, 500);
        }
        else
        {
            this.setState({buttonState: ButtonState.Error});
        }
    }

    private _getTitle():string
    {
        const {buttonState} = this.state;

        return buttonState === ButtonState.CopyToMyOrganization
            ? 'Use this template'
            : buttonState;
    }

    private _renderSpinner():React.ReactNode
    {
        const {buttonState} = this.state;

        if( buttonState === ButtonState.Copying )
        {
            return (
                <Spinner
                    className={cx('spinner')}
                    size={SpinnerSize.Medium_24}
                    style={SpinnerStyle.White}
                />
            );
        }

        return null;
    }

    public render()
    {
        const {buttonState} = this.state;

        return (
            <WSPButton
                className={cx('grabButton')}
                onClick={this._onClick}
                icon={buttonState === ButtonState.CopyToMyOrganization ? MDIcons.common.Copy : undefined}
                iconClassName={styles.icon}
                iconSize={MDIconSize.medium20}

                size={ButtonSize.Large}
                style={ButtonStyle.Raised}
                // caption={this._getTitle()}
            >
                {this._renderSpinner()}
                {this._getTitle()}
            </WSPButton>
        );
    }
}
